<template>
  <div class="container" id="landing-tab">
    <div class="container mx-auto">
      <div class="d-flex justify-content-center">
        <div class="landing-tab-wrapper" style="padding: 0; margin: 0 -6px">
          <ul class="nav nav-pills nav-fill" role="tablist">
            <li class="nav-item nav-border-override" role="presentation">
              <a
                  class="nav-link cursor-pointer"
                  :class="{ active: tab === 'recruitment' }"
                  id="recruitment-tab"
                  aria-controls="recruitment"
                  aria-selected="true"
                  @click="showTab('recruitment')"
              >
                Recruitment
              </a>
            </li>
            <li class="nav-item nav-border-override" role="presentation">
              <a
                  class="nav-link cursor-pointer"
                  :class="{ active: tab === 'onboarding' }"
                  id="onboarding-tab"
                  aria-controls="onboarding"
                  aria-selected="true"
                  @click="showTab('onboarding')"
              >
                On-boarding
              </a>
            </li>
            <li class="nav-item nav-border-override" role="presentation">
              <a
                  class="nav-link cursor-pointer"
                  :class="{ active: tab === 'retention' }"
                  id="retention-tab"
                  aria-controls="retention"
                  aria-selected="true"
                  @click="showTab('retention')"
              >
                {{ hrTitle }}
              </a>
            </li>
            <li class="nav-item nav-border-override" role="presentation">
              <a
                  class="nav-link cursor-pointer"
                  :class="{ active: tab === 'work' }"
                  id="work-tab"
                  aria-controls="work"
                  aria-selected="true"
                  @click="showTab('work')"
              >
                Dashboard
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-flex content">
      <div
          class="tab-pane fade show active"
          v-if="tab === 'recruitment'"
          id="recruitment"
          role="tabpanel"
          aria-labelledby="recruitment-tab"
      >
        <Recruitment/>
      </div>
      <div
          class="tab-pane fade show active"
          v-if="tab === 'onboarding'"
          id="onboarding"
          role="tabpanel"
          aria-labelledby="onboarding-tab"
      >
        <Onboarding/>
      </div>
      <div
          class="tab-pane fade show active"
          v-if="tab === 'retention'"
          id="retention"
          role="tabpanel"
          aria-labelledby="retention-tab"
      >
        <Hr :payrollEnabled="payrollEnabled"/>
      </div>
      <div
          class="tab-pane fade show active"
          v-if="tab === 'work'"
          id="work"
          role="tabpanel"
          aria-labelledby="work-tab"
      >
        <Dashboard/>
      </div>
    </div>
  </div>
</template>

<script>
import Recruitment from './Recruitment.vue';
import Onboarding from './Onboarding.vue';
import Hr from './Hr.vue';
import Dashboard from './Dashboard.vue';

export default {
  props : ['featureSettingsData'],
  components: { Recruitment, Onboarding, Hr, Dashboard },
  data () {
    return {
      tabs: {
        1: 'recruitment',
        2: 'onboarding',
        3: 'retention',
        4: 'work',
      },
      tab: 'recruitment',
    };
  },

  computed: {
    storedOption () {
      return this.$store.state.landingServiceSelected;
    },
    featureSettings () {
      return JSON.parse(this.featureSettingsData) ?? []
    },
    payrollEnabled () {
      return this.featureSettings?.payroll === 1 ?? false;
    },
    hrTitle () {
      return (this.payrollEnabled) ? 'HR & Payroll' : 'HR';
    },
  },

  watch: {
    storedOption () {
      this.tab = this.tabs[this.storedOption];
    }
  },

  methods: {
    showTab (tab) {
      this.tab = tab;
      this.$store.dispatch('setLandingServiceOption', Object.entries(this.tabs).filter((tab) => tab[1] === this.tab)[0][0]);
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-tab {
  &.container {
    @media (max-width: 768px) {
      padding: 0;
    }
  }

  .container {
    @media (max-width: 768px) {
      padding: 0;
    }
  }

  .landing-tab-wrapper {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    width: 620px;

    @media (max-width: 768px) {
      width: 100%;
    }

    .nav-link {
      padding-top: 26px;
      padding-bottom: 20px;

      @media (max-width: 768px) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .content {
    margin-top: 32px;
  }

  .archived-tab {
    margin-top: 25px;

    &__view {
      color: #0db4e6;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 22px;
      text-align: right;

      margin-bottom: 24px;
    }
  }
}
</style>
